<mat-card class="internal-form mat-elevation-z0 no-top-margin">
  <div class="internal-form-title">
    <div class="internal-form-title-text">Intern</div>
  </div>
  <div class="form-title bottom-space">
    <div class="form-title-text">Ontwerp</div>
  </div>
  <div *ngIf="inputProduct.newDesign === false" class="italic-text">
    Klant vraagt ontwerp Inpress
  </div>

  <yes-no
    [title]="'Ontwerp nodig'"
    [extraInstructions]="'Geef meer uitleg'"
    [nullIsFalse]="false"
    [alwaysShowExtraInstructions]="true"
    [value]="inputProduct.needsDesign"
    [inputText]="inputProduct.needsDesignDescription"
    [toShowDateLabel]="'Gewenst'"
    [toShowDate]="inputProduct.designByDate"
    [toShowASAP]="inputProduct.designASAP"
    [toShowEmployee]="inputProduct.designer"
    [showBoolean]="true"
    [toShowBoolean]="inputProduct.designFinished"
    [nullable]="true"
    (answer)="needsDesign($event)"
    (answeredText)="needsDesignText($event)"
  ></yes-no>

  <mat-card
    *ngIf="inputProduct.needsDesign"
    class="top-card mat-elevation-z0 overflowHidden"
  >
    <div
      *ngIf="inputProduct.needsDesign"
      [class.collapsed]="designIsCollapsed"
      class="section-header d-flex  overflowHidden clickable"
      (click)="toggleCollapseDesign()"
      [attr.aria-expanded]="!designIsCollapsed"
    >
      <div class="details-text">Details ontwerp</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div
      *ngIf="inputProduct.needsDesign"
      class="padding"
      [collapse]="designIsCollapsed"
      [isAnimated]="!safari"
    >
      <ng-container *ngIf="renderDesign | async">
        <div class="d-flex">
          <form class="form first-form-field">
            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                placeholder="Selecteer medewerker"
                required
                [(ngModel)]="inputProduct.designer"
                name="designer"
                (ngModelChange)="designerChange($event)"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of designerChoices"
                  [value]="option"
                >
                  <span *ngIf="option.user"
                    >{{ option.user.firstName }}
                    {{ option.user.lastName }}</span
                  >
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>

          <mat-form-field class="form-field-no-flex" appearance="outline">
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Selecteer een datum"
              [(ngModel)]="inputProduct.designByDate"
              name="designByDate"
              (ngModelChange)="designByDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="subtitle no-top-margin">Voorziene tijd ontwerper</div>

        <form class="form">
          <div class="d-flex">
            <div class="timeInput">
              <div class="selector-label">Uren</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="inputProduct.designerHourBudget"
                  name="designerHourBudget"
                  (ngModelChange)="setHours($event)"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of hours"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="largeText">:</div>

            <div class="timeInput">
              <div class="selector-label">Minuten</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="inputProduct.designerMinuteBudget"
                  name="designerMinuteBudget"
                  (ngModelChange)="setMinutes($event)"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of minutes"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="form-title">
          <div class="form-title-text">Klantinformatie</div>
        </div>

        <customer-project-info-all
          [inputProject]="inputProject"
          [inputProduct]="inputProduct"
          [updateEmitter]="updateProduct"
          [involvedCompanies]="involvedCompanies"
          [pmsColorAdded]="pmsColorAdded"
        ></customer-project-info-all>

        <yes-no
          [title]="'Mag het Inpress logo toegevoegd worden?'"
          [neverShowExtraInstructions]="true"
          [extraInstructions]="''"
          [value]="inputProduct.inpressLogo"
          [inputText]="''"
          [nullIsFalse]="false"
          [nullable]="true"
          (answer)="inpressLogoChanged($event)"
        ></yes-no>

        <div class="form-title bottom-space">
          <div class="form-title-text">Ontwerper</div>
        </div>

        <checkbox
          [title]="'Controle spelling'"
          [text]="'Ja, controle op typfouten werd uitgevoerd'"
          [checked]="inputProduct.spellCheck"
          (answer)="spellCheck($event)"
        >
        </checkbox>

        <logged-action-display
          *ngIf="inputProduct.spellCheckRegistration"
          [inputLoggedAction]="inputProduct.spellCheckRegistration"
        ></logged-action-display>

        <checkbox
          [title]="
            'Titel controleren (' +
            (inputProduct.title ? inputProduct.title : 'Titel ontbreekt') +
            ')'
          "
          [text]="'Titel is gecontroleerd'"
          [checked]="inputProduct.titleCheckedDesign"
          (answer)="titleCheckedDesignChange($event)"
        ></checkbox>

        <logged-action-display
          *ngIf="inputProduct.titleCheckedDesignRegistration"
          [inputLoggedAction]="inputProduct.titleCheckedDesignRegistration"
        ></logged-action-display>

        <checkbox
          [title]="'Telefoonnummer controleren (' + phoneNumberDisplay + ')'"
          [text]="'Telefoonnummer is gecontroleerd'"
          [checked]="inputProduct.phoneNumberCheckedDesign"
          (answer)="phoneNumberCheckedDesignChange($event)"
        ></checkbox>

        <logged-action-display
          *ngIf="inputProduct.phoneNumberCheckedDesignRegistration"
          [inputLoggedAction]="
            inputProduct.phoneNumberCheckedDesignRegistration
          "
        ></logged-action-display>

        <div class="upper-space">
          <file-picker
            class="flexed"
            [title]="'Ontwerp'"
            [inputProduct]="inputProduct"
            [formSection]="'internalDesign'"
            [uploadButtonLabel]="'Ontwerp toevoegen'"
          ></file-picker>

          <file-picker
            class="flexed"
            [title]="'Ontwerp + impressie'"
            [inputProduct]="inputProduct"
            [formSection]="getDesignFormSection()"
            [uploadButtonLabel]="'Ontwerp toevoegen'"
          ></file-picker>
        </div>

        <textarea-input
          [title]="'Opvolging ontwerp'"
          [placeholder]="'Geef info over/duiding aan het ontwerp'"
          [initContent]="inputProduct.emailText"
          (answer)="emailTextChange($event)"
        ></textarea-input>

        <checkbox
          [text]="'Het ontwerp is verzonden naar de klant'"
          [checked]="inputProduct.designSentToCustomer"
          (answer)="designSentToCustomerChange($event)"
        ></checkbox>

        <logged-action-display
          *ngIf="inputProduct.designSentLog"
          [inputLoggedAction]="inputProduct.designSentLog"
        ></logged-action-display>

        <div class="form-title upper-space">
          <div class="form-title-text">Feedback/Akkoord</div>
        </div>

        <yes-no
          [yesValue]="'De klant gaat akkoord met het ontwerp'"
          [noValue]="'De klant gaat niet akkoord met het ontwerp'"
          [nullIsFalse]="false"
          [neverShowExtraInstructions]="true"
          [value]="inputProduct.customerApproves"
          [nullable]="true"
          (answer)="customerApproves($event)"
        ></yes-no>

        <div
          *ngIf="inputProduct.designApprovalRegistration"
          class="lower-space"
        >
          <logged-action-display
            [inputLoggedAction]="inputProduct.designApprovalRegistration"
          ></logged-action-display>
        </div>

        <textarea-input
          *ngIf="inputProduct.customerApproves === false"
          [title]="'Reden geen akkoord'"
          [placeholder]="
            'Reden waarom de klant niet akkoord gaat met het ontwerp'
          "
          [initContent]="inputProduct.customerDisapprovalFeedback"
          (answer)="customerDisapprovalFeedbackChange($event)"
        ></textarea-input>

        <textarea-input
          *ngIf="inputProduct.customerApproves === false"
          [title]="'Verder verloop'"
          [placeholder]="
            'Beschrijf het verder verloop na niet akkoord (email opnieuw sturen, nieuwe designs uploaden, ...)'
          "
          [initContent]="inputProduct.customerDisapprovalAction"
          (answer)="customerDisapprovalActionChange($event)"
        ></textarea-input>

        <textarea-input
          *ngIf="inputProduct.customerApproves"
          [title]="'Feedback over het akkoord'"
          [placeholder]="'Geef kleine mededeling indien gewenst'"
          [initContent]="inputProduct.customerApprovalFeedback"
          (answer)="customerApprovalFeedbackChange($event)"
        ></textarea-input>

        <textarea-input
          *ngIf="inputProduct.customerApproves"
          [title]="'Akkoord klant (persoon)'"
          [placeholder]="
            'Noteer naam van diegene die het ontwerp goedgekeurd heeft'
          "
          [initContent]="inputProduct.approvedBy"
          (answer)="customerApprovedByChange($event)"
        ></textarea-input>

        <div class="form-title">
          <div class="form-title-text">Indien ontwerp klaar</div>
        </div>

        <dual-checkbox
          [title]="'Upload het design naar printer'"
          [checked]="[inputProduct.printByMutoh, inputProduct.printByAgfa]"
          [leftText]="'Ja, bestand verzonden naar Printer Mutoh'"
          [rightText]="'Ja, bestand verzonden naar Agfa'"
          (answer)="printByChange($event)"
        ></dual-checkbox>

        <div *ngIf="isBoard()">
          <textarea-input
            [title]="'Tiling formaten'"
            [placeholder]="'Aantal borden + afmetingen'"
            [initContent]="inputBoard.tilingFormats"
            (answer)="tilingFormatsChange($event)"
          ></textarea-input>
        </div>

        <app-tiling
          *ngIf="isWindowSticker() || isCustomWindowSticker()"
          [inputTilingAware]="inputProduct"
          (output)="updateProduct.emit()"
        ></app-tiling>

        <file-picker
          *ngIf="!isOtherProduct()"
          class="flexed"
          [title]="'Ontwerp met tiling'"
          [inputProduct]="inputProduct"
          [formSection]="'tilingDesign'"
          [uploadButtonLabel]="'Ontwerp toevoegen'"
        ></file-picker>

        <div class="form-sub-title-no-bottom-margin">Afgewerkt</div>

        <checkbox
          [text]="'Het ontwerp is afgewerkt'"
          [checked]="inputProduct.designFinished"
          [trueVerification]="designFinishedVerificationCallback"
          (answer)="designFinishedChange($event)"
        ></checkbox>
      </ng-container>
    </div>
  </mat-card>

  <div class="form-title">
    <div class="form-title-text">Printwerk</div>
  </div>

  <yes-no
    [title]="'Printwerk nodig'"
    [value]="inputProduct.needPrintwork"
    [alwaysShowExtraInstructions]="true"
    [extraInstructions]="'Geef extra informatie (bv. externe leverancies, ...'"
    [inputText]="inputProduct.noPrintworkExtraInfo"
    [nullIsFalse]="false"
    [toShowDateLabel]="'Gewenst'"
    [toShowDate]="inputProduct.printworkByDate"
    [toShowASAP]="inputProduct.printworkASAP"
    [toShowEmployee]="inputProduct.printworkHandler"
    [showBoolean]="true"
    [toShowBoolean]="inputProduct.printWorkReady"
    [nullable]="true"
    (answer)="printWork($event)"
    (answeredText)="noPrintworkExtraInfoChange($event)"
  ></yes-no>

  <mat-card
    *ngIf="inputProduct.needPrintwork"
    class="top-card mat-elevation-z0 overflowHidden"
  >
    <div
      *ngIf="inputProduct.needPrintwork"
      [class.collapsed]="printworkIsCollapsed"
      class="section-header  d-flex  overflowHidden clickable"
      (click)="toggleCollapsePrintwork()"
      [attr.aria-expanded]="!printworkIsCollapsed"
    >
      <div class="details-text">Details printwerk</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>

    <div
      *ngIf="inputProduct.needPrintwork"
      class="padding"
      [collapse]="printworkIsCollapsed"
      [isAnimated]="!safari"
    >
      <ng-container *ngIf="renderPrintwork | async">
        <div class="d-flex">
          <form class="form first-form-field">
            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                placeholder="Selecteer medewerker"
                required
                [(ngModel)]="inputProduct.printworkHandler"
                name="printworkHandler"
                (ngModelChange)="printworkHandlerChange($event)"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of printworkHandlerChoices"
                  [value]="option"
                >
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>

          <mat-form-field class="form-field-no-flex" appearance="outline">
            <input
              matInput
              [matDatepicker]="printworkByPicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="inputProduct.printworkByDate"
              name="printworkByDate"
              (ngModelChange)="printworkByDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="printworkByPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #printworkByPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <textarea-input
          [title]="'Opvolging printwerk'"
          [placeholder]="'Geef info over de opvolging van het printwerk'"
          [initContent]="inputProduct.printworkFollowUp"
          (answer)="printworkFollowUpChange($event)"
        ></textarea-input>

        <checkbox
          [title]="
            'Titel controleren (' +
            (inputProduct.title ? inputProduct.title : 'Titel ontbreekt') +
            ')'
          "
          [text]="'Titel is gecontroleerd'"
          [checked]="inputProduct.titleCheckedPrintWork"
          (answer)="titleCheckedPrintWorkChange($event)"
        ></checkbox>

        <logged-action-display
          *ngIf="inputProduct.titleCheckedPrintWorkRegistration"
          [inputLoggedAction]="inputProduct.titleCheckedPrintWorkRegistration"
        ></logged-action-display>

        <checkbox
          [title]="'Printwerk klaar'"
          [text]="'Ja, printwerk klaar'"
          [checked]="inputProduct.printWorkReady"
          [trueVerification]="printWorkReadyVerificationCallback"
          (answer)="printWorkReady($event)"
        >
        </checkbox>

        <logged-action-display
          *ngIf="inputProduct.printWorkReadyRegistration"
          [inputLoggedAction]="inputProduct.printWorkReadyRegistration"
        ></logged-action-display>
      </ng-container>
    </div>
  </mat-card>

  <div class="form-title">
    <div class="form-title-text">Afwerking</div>
  </div>

  <yes-no
    [title]="'Afwerking nodig'"
    [extraInstructions]="'Meer informatie (bv. schoonsnijden, ...)'"
    [alwaysShowExtraInstructions]="true"
    [value]="inputProduct.needFinish"
    [inputText]="inputProduct.finishDescription"
    [nullIsFalse]="false"
    [toShowDateLabel]="'Gewenst'"
    [toShowDate]="inputProduct.finishByDate"
    [toShowASAP]="inputProduct.finishASAP"
    [toShowEmployee]="inputProduct.finisher"
    [showBoolean]="true"
    [toShowBoolean]="inputProduct.finishReady"
    [nullable]="true"
    (answer)="needFinish($event)"
    (answeredText)="finishDescription($event)"
  ></yes-no>

  <mat-card
    *ngIf="inputProduct.needFinish"
    class="top-card mat-elevation-z0 overflowHidden"
    style="margin-top: -18.813px;"
  >
    <div
      *ngIf="inputProduct.needFinish"
      [class.collapsed]="finishIsCollapsed"
      class="section-header d-flex  overflowHidden clickable"
      (click)="toggleCollapseFinish()"
      [attr.aria-expanded]="!finishIsCollapsed"
    >
      <div class="details-text">Details afwerking</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div
      *ngIf="inputProduct.needFinish"
      class="padding"
      [collapse]="finishIsCollapsed"
      [isAnimated]="!safari"
    >
      <ng-container *ngIf="renderFinish | async">
        <div class="d-flex">
          <form class="form first-form-field">
            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                placeholder="Selecteer medewerker"
                required
                [(ngModel)]="inputProduct.finisher"
                name="finisher"
                (ngModelChange)="finisherChange($event)"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of finisherChoices"
                  [value]="option"
                >
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>

          <mat-form-field class="form-field-no-flex" appearance="outline">
            <input
              matInput
              [matDatepicker]="finishByPicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="inputProduct.finishByDate"
              name="finishByDate"
              (ngModelChange)="finishByDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="finishByPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #finishByPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <checkbox
          *ngIf="
            isWindowSticker() &&
            inputWindowsticker.tiling &&
            inputProduct.needPrintwork
          "
          [title]="'Panden tellen (tiling)'"
          [text]="'Aantal panden correct en nagemeten'"
          [checked]="inputWindowsticker.numPandOk"
          (answer)="numPandOk($event)"
        ></checkbox>

        <div class="subtitle">Voorziene tijd afwerking</div>

        <form class="form">
          <div class="d-flex">
            <div class="timeInput">
              <div class="selector-label">Uren</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  name="finisherHourBudget"
                  [(ngModel)]="inputProduct.finisherHourBudget"
                  name="finisherHourBudget"
                  (ngModelChange)="setFinishHours($event)"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of hours"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="largeText">:</div>

            <div class="timeInput">
              <div class="selector-label">Minuten</div>
              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="inputProduct.finisherMinuteBudget"
                  name="finisherMinuteBudget"
                  (ngModelChange)="setFinishMinutes($event)"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of minutes"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>

        <checkbox
          [title]="'Afwerking klaar'"
          [text]="'Afwerking klaar en weggezet'"
          [checked]="inputProduct.finishReady"
          (answer)="finishReady($event)"
        >
        </checkbox>

        <logged-action-display
          *ngIf="inputProduct.finishReadyRegistration"
          [inputLoggedAction]="inputProduct.finishReadyRegistration"
        ></logged-action-display>
      </ng-container>
    </div>
  </mat-card>
</mat-card>
